import { FC } from 'react';
import NumberFormat from 'react-number-format';
import classes from '../../asset/css/pickup/pickup-shipping-product-list.module.css';
import { ProductInfoViewType } from '../../types/view/product-info-view-type';

export const PickupProductItem: FC<{
  productItem: ProductInfoViewType;
  loading: boolean;
  cancelSubscriptionFunc: (lineId?: string) => void;
  updateQuantityFunc?: (lineId: string, quantity: number) => void;
}> = ({ productItem, loading, cancelSubscriptionFunc, updateQuantityFunc }) => {
  console.log('productItem here', productItem);
  const priceBlock = (
    <span className={classes.item_info_price_current}>
      <small>割引価格</small> ￥<NumberFormat displayType="text" value={productItem.price} thousandSeparator={true} />
    </span>
  );
  //  productItem.originalPrice === productItem.price ? (
  //    <>
  //      <span className={classes.item_info_price_current}>
  //        ￥<NumberFormat displayType="text" value={productItem.price} thousandSeparator={true} />
  //      </span>
  //    </>
  //  ) : (
  //    <>
  //      <span className={classes.item_info_price_original}>
  //        ￥<NumberFormat displayType="text" value={productItem.originalPrice} thousandSeparator={true} />
  //      </span>
  //      <span className={classes.item_info_price_arrow}>→</span>
  //      <span className={classes.item_info_price_current}>
  //        ￥<NumberFormat displayType="text" value={productItem.price} thousandSeparator={true} />
  //      </span>
  //    </>
  //  );

  return (
    <li className={classes.item}>
      <a href={productItem.url} target="_blank" className={classes.item_thumbnail}>
        <div
          style={productItem.image ? { backgroundImage: `url('${productItem.image}')` } : {}}
          className={classes.item_thumbnail_img}
        />
      </a>

      <div className={classes.item_info}>
        {/* 商品名と価格 */}
        <div className={classes.item_info_titlePrice}>
          {/* 商品名 */}
          <h4 className={classes.item_info_title}>{productItem.productTitle}</h4>
          {/* {productItem.variantTitle && (
            <div className={classes.item_info_variantTitle}>{productItem.variantTitle}</div>
          )} */}

          {/* 商品価格 */}
          <div className={classes.item_info_price}>{priceBlock}</div>
        </div>

        {/* アクションボタン */}
        <div className={classes.item_info_actions}>
          {/* 停止ボタン */}
          <span className={classes.item_info_actions_addedLabel}>追加済</span>
        </div>
      </div>
    </li>
  );
};
